export const dateFormat = {
	engDays: 'DD/MM/YYYY',
	englishDatePicker: 'dd/MM/yyyy',
	engHours: 'DD/MM/YYYY hh:mm A',
	apiFormat: 'YYYY/MM/DD HH:mm:ss',
}
